module.exports = "/src/views/games/other/images/roles/komisar.png";